module.exports = __webpack_public_path__ + "img/icon28.17c1af16.png";